function CurrentConditionsLoader() {
  return (
    <div data-testid="current-conditions-loader" className="mb-6 animate-pulse">
      <div className="mb-6">
        <div className="mb-2 h-8 w-16 rounded bg-slate-300"></div>
        <div className="h-3 w-24 rounded bg-slate-300"></div>
      </div>

      <div className="mb-2 flex items-center justify-between">
        <div className="h-16 w-16 rounded bg-slate-300"></div>
        <div className="h-16 w-16 rounded bg-slate-300"></div>
      </div>

      <div className="mb-4 flex items-center justify-between">
        <div className="h-4 w-32 rounded bg-slate-300"></div>
        <div className="h-4 w-20 rounded bg-slate-300"></div>
      </div>

      <div className="grid grid-flow-col grid-rows-6 gap-x-4 sm:grid-rows-3">
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
        <div className="flex justify-between border-b border-b-slate-300/70 py-2">
          <div className="h-4 w-24 rounded bg-slate-300"></div>
          <div className="h-4 w-8 rounded bg-slate-300"></div>
        </div>
      </div>
    </div>
  );
}

export default CurrentConditionsLoader;
